// extracted by mini-css-extract-plugin
export default {"main":"RemoveFilterButton_main__5d5Nz"};